export default __webpack_public_path__ + "static/media/benefit_3.a052e051.png";